<span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-2.5 bg-gray-050">
	<ui-icon
		width="20"
		height="20"
		aria-hidden="true"
		[iconName]="request().stateIcon"
		[class]="request().stateClass" />
</span>
<span class="flex min-w-0 flex-1 flex-col gap-1.5">
	<span class="flex min-w-0 items-center justify-end gap-1.5">
		<span class="min-w-0 flex-1 truncate text-xs font-medium text-gray-900">{{ request().title }}</span>
		@if (showChip()) {
			<ui-chip size="xs" [label]="request().stateLabel" [tip]="request().stateTip" />
		}
	</span>
	<span class="flex items-center justify-between gap-2 whitespace-nowrap text-xs text-gray-900">
		<span class="truncate text-right" dir="ltr">{{ request().dateLabel }}</span>
		<span class="flex shrink-0 items-center gap-1">
			<ui-number format="1.0-0" dir="ltr" [value]="request().amount" />
			<span>ریال</span>
		</span>
	</span>
</span>
<span class="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-gray-300">
	<ui-icon width="20" height="20" iconName="chevron-left" aria-hidden="true" />
</span>
